// helpers/userTypeHelpers.js
export const getUserType = () => localStorage.getItem("userType");

export const setUserType = (userType) => {
  if (userType) localStorage.setItem("userType", userType);
  else localStorage.removeItem("userType");
};

export const clearUserType = () => {
  localStorage.removeItem("userType");
};
